import {
  BpkCalendarGrid,
  type BpkCalendarGridProps,
} from '@skyscanner-internal/backpack-web/bpk-component-calendar';
import { BpkExtraLargeSpinner } from '@skyscanner-internal/backpack-web/bpk-component-spinner';
import { useSelector } from 'react-redux';

import { isLoading, isUserDateSelectionAllowed } from '../../selectors';

import './GridWithLoading.scss';

function PricedCalendarGrid(props: BpkCalendarGridProps) {
  const loading = useSelector(isLoading);
  const userDateSelectionAllowed = useSelector(isUserDateSelectionAllowed);
  const hideGrid = loading || !userDateSelectionAllowed;
  const dataState = hideGrid ? '--data-loading' : '--data-loaded';

  return (
    <div
      className="month-view-grid-wrapper"
      data-newrelic-synthetic={hideGrid ? undefined : 'mvp-grid-loaded'}
      data-percy-id={hideGrid ? undefined : 'grid-loaded'}
    >
      <BpkExtraLargeSpinner className={`month-view-spinner${dataState}`} />
      <BpkCalendarGrid {...props} className={`month-view-grid${dataState}`} />
    </div>
  );
}

export default PricedCalendarGrid;
